// Import this from your server's city codes or maintain a copy here
export const CITY_CODES = {
  "29 Palms": "29P",
  "Acton": "AC",
  "Adelanto": "AD",
  "Agoura": "AGO",
  "Agoura Hills": "AGHI",
  "Agua Dulce": "ADUL",
  "Aguanga": "AGNA",
  "Alberhill": "ALHL",
  "Alhambra": "ALH",
  "Aliso Viejo": "AV",
  "Alpine": "ALP",
  "Alta Loma": "ALTL",
  "Altadena": "ALTA",
  "Anaheim": "ANA",
  "Anaheim Hills": "AH",
  "Angeles Oaks": "ANGO",
  "Anza": "ANZA",
  "Apple Valley": "APPV",
  "Arcadia": "ARCD",
  "Arleta": "ARL",
  "Arrowbear": "AB",
  "Artesia": "ART",
  "Atwater": "ATW",
  "Avalon": "AVAL",
  "Azusa": "AZU",
  "Bakersfield": "BKSF",
  "Baldwin Park": "BDPK",
  "Banning": "BANN",
  "Barstow": "BSTW",
  "Bassett": "BST",
  "Beaumont": "BMT",
  "Bel Air": "BELA",
  "Bell": "BELL",
  "Bell Canyon": "BC",
  "Bell Gardens": "BG",
  "Bellflower": "BF",
  "Bermuda Dunes": "BD",
  "Beverly Hills": "BEVH",
  "Big Bear": "BB",
  "Bloomington": "BLM",
  "Blythe": "BLY",
  "Bonita": "BON",
  "Bonsall": "BNSL",
  "Borrega Springs": "BSPG",
  "Boulevard": "BOU",
  "Bradbury": "BRAD",
  "Brea": "BREA",
  "Brentwood": "BREN",
  "Buena Park": "BP",
  "Bullhead City": "BULH",
  "Burbank": "BBK",
  "Cabazon": "CABA",
  "Cahuenga Pass": "CPS",
  "Calabasas": "CLB",
  "Calabasas Highlands": "CBH",
  "Calabasas Park": "CBP",
  "California City": "CACY",
  "Calimesa": "CALI",
  "Camarillo": "CAM",
  "Campo": "CAMP",
  "Canoga Park": "CP",
  "Canyon Areas": "CA",
  "Canyon Country": "CANC",
  "Canyon Lake": "CLK",
  "Cardiff by the Sea": "CAS",
  "Carlsbad": "CAR",
  "Carmel Valley": "CAV",
  "Carson": "CARS",
  "Castaic": "CAST",
  "Cathedral City": "CC",
  "Cerritos": "CER",
  "Chatsworth": "CHT",
  "Cherry Valley": "CHVL",
  "Chino": "CH",
  "Chino Hills": "CHH",
  "Chula Vista": "CHU",
  "City of Commerce": "COM",
  "City of Industry": "COI",
  "Clairemont Mesa": "CLM",
  "Claremont": "CLAR",
  "Coachella": "COA",
  "Colton": "CLTN",
  "Compton": "CMP",
  "Corona": "COR",
  "Corona Del Mar": "CDM",
  "Coronado": "CORO",
  "Costa Mesa": "CM",
  "Coto De Caza": "CDC",
  "Cottonwood Canyon": "COTT",
  "Covina": "CVN",
  "Crestline": "CRLN",
  "Cudahy": "CUD",
  "Culver City": "CULV",
  "Cypress": "CYP",
  "Dana Point": "DP",
  "Del Cerro": "DEC",
  "Del Mar": "DEM",
  "Descanso": "DES",
  "Desert Center": "DCTR",
  "Desert Hot Springs": "DHS",
  "Desert Shores": "DS",
  "Devore": "DEVO",
  "Diamond Bar": "DB",
  "Downey": "DOW",
  "Duarte": "DUAR",
  "Dulzura": "DUL",
  "Eagle Rock": "EAGL",
  "East San Diego": "ESD",
  "El Cajon": "ELC",
  "El Cerrito": "ELCE",
  "El Monte": "ELM",
  "El Segundo": "ES",
  "El Sereno": "ESER",
  "Encinitas": "ENCS",
  "Encino": "ENC",
  "Escondido": "ESC",
  "Fallbrook": "FBRK",
  "Fillmore": "FIL",
  "Fontana": "FONT",
  "Forest Falls": "FRFL",
  "Fountain Valley": "FV",
  "Frazier Park": "FRZ",
  "French Valley": "FRVL",
  "Fullerton": "FUL",
  "Garden Grove": "GG",
  "Gardena": "GR",
  "Garner Valley": "GRVL",
  "Garnet": "GARN",
  "Glassell Park": "GPRK",
  "Glen Avon": "GAV",
  "Glen Helen": "GLHL",
  "Glen Ivy": "GLIV",
  "Glendale": "GD",
  "Glendora": "GLDR",
  "Goodhope": "GDHP",
  "Granada Hills": "GH",
  "Grand Terrace": "GRTR",
  "Green Valley": "GRV",
  "Grover Beach": "GRVC",
  "Guatay": "GUA",
  "Hacienda Heights": "HH",
  "Harbor City": "HC",
  "Havasu City": "HVCY",
  "Hawaiian Gardens": "HG",
  "Hawthorne": "HAWT",
  "Hemet": "HMT",
  "Hermosa Beach": "HMB",
  "Hesperia": "HSP",
  "Hidden Hills": "HHIL",
  "Highgrove": "HGRV",
  "Highland": "HLND",
  "Highland Park": "HDPK",
  "Hollydale": "HLDL",
  "Hollywood": "HLW",
  "Homeland": "HOME",
  "Honolulu": "HNLU",
  "Hornbrook": "HNBK",
  "Huntington Beach": "HB",
  "Huntington Park": "HNPK",
  "Idyllwild": "IWLD",
  "Imperial Beach": "IMB",
  "Imperial City": "IMC",
  "Indian Wells": "IW",
  "Indio": "IND",
  "Inglewood": "ING",
  "Irvine": "IR",
  "Irwindale": "IRW",
  "Jacumba": "JAC",
  "Jamul": "JAM",
  "Joshua Tree": "JT",
  "Julian": "JUL",
  "Juniper Flats": "JFLT",
  "Kagel Canyon": "KGY",
  "La Canada Flintridge": "LCF",
  "La Crescenta": "LACR",
  "La Habra": "LH",
  "La Habra Heights": "LHH",
  "La Jolla": "LAJ",
  "La Mesa": "LMSA",
  "La Mirada": "LAM",
  "La Palma": "LP",
  "La Puente": "LPUE",
  "La Quinta": "LQ",
  "La Sierra": "LS",
  "La Verne": "LVRN",
  "Ladera Heights": "LADH",
  "Laguna Beach": "LB",
  "Laguna Hills": "LAGH",
  "Laguna Niguel": "LN",
  "Laguna Woods": "LAGW",
  "Lake Arrowhead": "LKAR",
  "Lake Elizabeth": "EZB",
  "Lake Elsinore": "LKEL",
  "Lake Forest": "LF",
  "Lake Havasu": "LHSU",
  "Lake Hughes": "LKH",
  "Lake Los Angeles": "LKL",
  "Lake Matthews": "LKMA",
  "Lake Sherwood": "LKS",
  "Lakeside": "LAK",
  "Lakeview Terrace": "LVT",
  "Lakewood": "LW",
  "Lancaster": "LNCR",
  "Landers": "LNDR",
  "Lawndale": "LAWN",
  "Lemon Grove": "LEG",
  "Lennox": "LX",
  "Leona Valley": "LVY",
  "Lincoln Heights": "LHTS",
  "Linda Vista": "LIV",
  "Little Rock": "LTLR",
  "Logan Heights": "LOH",
  "Loma Linda": "LOML",
  "Lomita": "LOM",
  "Long Beach": "LONG",
  "Los Alamitos": "LOSA",
  "Los Angeles (City)": "LA",
  "Los Angeles (County)": "CO",
  "Los Feliz": "LFE",
  "Lucerne Valley": "LUCV",
  "Lynwood": "LNWD",
  "Lytle Creek": "LCRK",
  "Malibu": "MLBU",
  "Manhattan Beach": "MANH",
  "Mar Vista": "MARV",
  "Marina Del Rey": "MR",
  "Maywood": "MW",
  "Mead Valley": "MVLY",
  "Meadowbrook": "MBRK",
  "Mecca": "MEC",
  "Menifee": "MENF",
  "Mentone": "MENT",
  "Midway City": "MC",
  "Mira Loma": "MILO",
  "Mira Mesa": "MIM",
  "Miramar": "MIR",
  "Mission Hills San Diego": "MIH",
  "Mission Hills San Fernando": "MH",
  "Mission Valley": "MIV",
  "Mission Viejo": "MV",
  "Monrovia": "MNRO",
  "Montclair": "MCLR",
  "Montebello": "MTB",
  "Montecito Heights": "MHTS",
  "Monterey Hills": "MHIL",
  "Monterey Park": "MP",
  "Montrose": "MTR",
  "Moorpark": "MPK",
  "Moreno Valley": "MORV",
  "Morongo Valley": "MGOV",
  "Morro Bay": "MRBY",
  "Mount Baldy": "MTBL",
  "Mount Laguna": "MOL",
  "Mount Washington": "MWSH",
  "Mountain Center": "MNTC",
  "Murrieta": "MUR",
  "National City": "NAC",
  "Needles": "NEED",
  "Newberry Spring": "NBS",
  "Newbury Park": "NPK",
  "Newhall": "NEWH",
  "Newport Beach": "NB",
  "Newport Coast": "NC",
  "Norco": "NORC",
  "North Hills": "NOH",
  "North Hollywood": "NHLW",
  "North Park": "NOP",
  "North Shore": "NSH",
  "North Tustin": "NTUS",
  "Northridge": "NR",
  "Norwalk": "NWK",
  "Nuevo/Lakeview": "NUEV",
  "Oak Glen": "OAKG",
  "Oasis": "OAS",
  "Ocean Beach": "OCB",
  "Oceanside": "OCE",
  "Ojai": "OJAI",
  "Olancha": "OLAN",
  "Old Town San Diego": "OTS",
  "Ontario": "ONT",
  "Orange": "ORG",
  "Orange Park Acres": "OPA",
  "Ortega Mountain": "ORTG",
  "Otay Mesa": "OTM",
  "Out of Area": "OA",
  "Outside State": "OS",
  "Oxnard": "OXN",
  "Pacific Beach": "PAB",
  "Pacific Palisades": "PACP",
  "Pacoima": "PAC",
  "Pala": "PAL",
  "Palm Desert": "PDST",
  "Palm Springs": "PSPR",
  "Palmdale": "PDL",
  "Palomar Mountain": "PAM",
  "Palos Verdes Estates": "PVE",
  "Palos Verdes Peninsula": "PVP",
  "Panorama City": "PC",
  "Paradise Hills": "PAH",
  "Paramount": "PAR",
  "Pasadena": "PAS",
  "Pauma Valley": "PAU",
  "Pearblossom": "PBLM",
  "Pedley": "PED",
  "Perris": "PRS",
  "Phelan": "PHEL",
  "Phillips Ranch": "PRCH",
  "Pico Rivera": "PR",
  "Pine Cove": "PNCV",
  "Pine Mountain": "PINM",
  "Pine Valley": "PIV",
  "Pinon Hills": "PINH",
  "Pinyon Pines": "PIN",
  "Placentia": "PLA",
  "Playa Del Rey": "PDLR",
  "Point Loma": "POL",
  "Pomona": "POM",
  "Porterville": "PORT",
  "Potrero": "POT",
  "Poway": "POW",
  "Quail Valley": "QVLY",
  "Quartz Hill": "QHL",
  "Rainbow": "RNBW",
  "Ramona": "RAM",
  "Ranchita": "RAN",
  "Rancho Bernardo": "RAB",
  "Rancho California": "RCA",
  "Rancho Cucamonga": "RCUC",
  "Rancho Dominguez": "RDOM",
  "Rancho Mirage": "RM",
  "Rancho Palos Verdes": "RPV",
  "Rancho Penasquitos": "RAP",
  "Rancho Santa Fe": "RAS",
  "Rancho Santa Margarita": "RSM",
  "Redlands": "REDL",
  "Redman": "RDMN",
  "Redondo Beach": "REDO",
  "Reseda": "RES",
  "Rialto": "RLT",
  "Ridgecrest": "RCR",
  "Riverside (City)": "RVSD",
  "Rolling Hills": "RH",
  "Rolling Hills Estates": "RHE",
  "Romoland": "RMLD",
  "Romona": "RMNA",
  "Rosamond": "ROSA",
  "Rosemead": "RSMD",
  "Rossmoor": "ROSS",
  "Rowland Heights": "ROW",
  "Rubidoux": "RBDX",
  "Running Springs Area": "RSA",
  "Sage": "SAGE",
  "Salton City": "SALT",
  "San Bernardino (City)": "SB",
  "San Carlos": "SAC",
  "San Clemente": "SC",
  "San Diego (City)": "SD",
  "San Dimas": "SDMS",
  "San Fernando": "SF",
  "San Gabriel": "SGAB",
  "San Jacinto": "SJCN",
  "San Jose": "SJOS",
  "San Juan Capistrano": "SJ",
  "San Luis Rey": "SLR",
  "San Marcos": "SAM",
  "San Marino": "SMRO",
  "San Pedro": "SP",
  "San Ysidro": "SYSI",
  "Sand Canyon": "SCN",
  "Santa Ana": "SA",
  "Santa Ana Heights": "SAH",
  "Santa Clarita": "SCL",
  "Santa Fe Springs": "SFS",
  "Santa Monica": "SMCA",
  "Santa Paula": "SPL",
  "Santa Rosa": "SAR",
  "Santa Ysabel": "SYSA",
  "Santee": "SAN",
  "Saugus": "SAU",
  "Scripps Miramar": "SCM",
  "Seal Beach": "SLB",
  "Sedco": "SEDC",
  "Sequim": "SEQM",
  "Shadow Hills": "SHH",
  "Sherman Oaks": "SO",
  "Sierra Madre": "SMAD",
  "Signal Hill": "SIGH",
  "Silver Lake": "SVL",
  "Simi Valley": "SIM",
  "Sky Valley": "SV",
  "Solana Beach": "SOL",
  "Somis": "SOM",
  "Sorrento": "SOR",
  "South El Monte": "SELM",
  "South Gate": "SOG",
  "South Pasadena": "SPAS",
  "Spring Valley": "SPV",
  "Stanton": "STAN",
  "Stevenson Ranch": "SR",
  "Studio City": "STUD",
  "Sugar Loaf": "SGLF",
  "Sun City": "SUNC",
  "Sun Valley": "SUNV",
  "Sunland": "SUNL",
  "Sunnymead": "SNMD",
  "Sunset Beach": "SSB",
  "Surfside": "SURF",
  "Sylmar": "SYL",
  "Tarzana": "TAR",
  "Tecate": "TEC",
  "Tehachapi": "THP",
  "Temecula": "TEM",
  "Temple City": "TMPL",
  "Thermal": "TH",
  "Thousand Oaks": "TO",
  "Thousand Palms": "TP",
  "Tierrasanta": "TIE",
  "Toluca Lake": "TUL",
  "Topanga": "TOP",
  "Torrance": "TORR",
  "Tujunga": "TUJ",
  "Tustin": "TUS",
  "Universal City": "UCTY",
  "University City": "UNIV",
  "Upland": "UPL",
  "Valencia": "VAL",
  "Valley Center": "VC",
  "Valley Glen": "VG",
  "Valley Village": "VVL",
  "Van Nuys - East": "VNE",
  "Van Nuys - West": "VNW",
  "Venice": "VEN",
  "Ventura": "VENT",
  "Vernon": "VERN",
  "Victor Valley": "VTVL",
  "Victorville": "VCVL",
  "Villa Park": "VP",
  "Vista": "VST",
  "Walnut": "WAL",
  "Walnut Park": "WP",
  "Warner Springs": "WSPR",
  "West Covina": "WCOV",
  "West Hills": "WEH",
  "West Hollywood": "WHO",
  "Westchester": "WS",
  "Westlake Village": "WLV",
  "Westminster": "WTM",
  "Westwood - Century City": "WCC",
  "Whittier": "WH",
  "Wilderville": "WDVL",
  "Wildomar": "WILD",
  "Wilmington": "WILM",
  "Wilson Valley": "WVLY",
  "Winchester": "WINC",
  "Winnetka": "WIN",
  "Woodcrest": "WOOD",
  "Woodland Hills": "WHLL",
  "Wrightwood": "WRWD",
  "Yorba Linda": "YL",
  "Yucaipa": "YUCP",
  "Yucca Valley": "YCCV"
};

// Create a prioritized list of cities
export const PRIORITIZED_CITIES = [
  // Most common cities first
  "Los Angeles (City)",
  "San Diego (City)",
  "Anaheim",
  "Santa Ana",
  "Riverside (City)",
  "San Bernardino (City)",
  "Irvine",
  "Long Beach",
  "Garden Grove",
  "Orange",
  // Then all other cities alphabetically
  ...Object.keys(CITY_CODES).filter(city => 
    !["Los Angeles (City)", "San Diego (City)", "Anaheim", "Santa Ana", 
      "Riverside (City)", "San Bernardino (City)", "Irvine", "Long Beach",
      "Garden Grove", "Orange"].includes(city)
  ).sort()
]; 